import {Permissions} from "@/js/Permissions";

const ResearchRoutes = [
  {
    path: "/research/batch-upload",
    name: "research_batch_upload",
    component: () => import("@/views/research/BatchUpload.vue"),
    meta: {permissions: [Permissions.RESEARCH_ARCHIVE]},
  },
  {
    path: "/research",
    name: "research_index",
    component: () => import("@/views/research/IndexView.vue"),
    meta: {permissions: [Permissions.RESEARCH]},
  },
  {
    path: "/research/companies",
    name: "kepler_companies",
    component: () => import("@/views/research/portal/companies/IndexView.vue"),
    meta: {permissions: [Permissions.KEPLER_PORTAL_COMPANIES]},
  },
  {
    path: "/research/companies/create",
    name: "kepler_companies_create",
    component: () => import("@/views/research/portal/companies/CreateView.vue"),
    meta: {permissions: [Permissions.KEPLER_PORTAL_COMPANIES]},
  },
  {
    path: "/research/companies/:id",
    name: "kepler_companies_edit",
    component: () => import("@/views/research/portal/companies/EditView.vue"),
    meta: {permissions: [Permissions.KEPLER_PORTAL_COMPANIES]},
  },
  {
    path: "/research/create",
    name: "research_create",
    component: () => import("@/views/research/CreateView.vue"),
    meta: {permissions: [Permissions.RESEARCH]},
  },
  {
    path: "/research/:id",
    name: "research_edit",
    component: () => import("@/views/research/EditView.vue"),
    meta: {permissions: [Permissions.RESEARCH, Permissions.PREVIEW_RESEARCH]},
  },
]

export default ResearchRoutes;
